var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","loading":_vm.exporting,"disabled":_vm.disabled || _vm.exporting},on:{"click":_vm.exportToExcel}},[_vm._v(" Exportar para Excel ")])}
var staticRenderFns = []

export { render, staticRenderFns }